import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { lazyWithRetry } from "@/lib/lazyWithRetry";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ResetPassword from "./pages/ResetPassword";
import { loadPricingSettings } from "./lib/pricingSettings";
import { loadAccessoryOverrides } from "./lib/accessoriesCatalog";
import { supabase } from "./integrations/supabase/client";

const Kitchens = lazyWithRetry(() => import("./pages/Kitchens"));
const Bathrooms = lazyWithRetry(() => import("./pages/Bathrooms"));

const LancasterCounty = lazyWithRetry(() => import("./pages/LancasterCounty"));
const ChesterCounty = lazyWithRetry(() => import("./pages/ChesterCounty"));
const BerksCounty = lazyWithRetry(() => import("./pages/BerksCounty"));

const ContractorLogin = lazyWithRetry(() => import("./pages/contractor/ContractorLogin"));
const ContractorDashboard = lazyWithRetry(() => import("./pages/contractor/ContractorDashboard"));
const ProjectDetail = lazyWithRetry(() => import("./pages/contractor/ProjectDetail"));


const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    loadPricingSettings();
    loadAccessoryOverrides();
    // pricing_settings is only readable once signed in — retry after auth lands.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) loadPricingSettings(true);
    });
    return () => subscription.unsubscribe();
  }, []);
  return (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/kitchens" element={<Suspense fallback={<div className="min-h-screen" />}><Kitchens /></Suspense>} />
          <Route path="/bathrooms" element={<Suspense fallback={<div className="min-h-screen" />}><Bathrooms /></Suspense>} />
          
          <Route path="/lancaster-county-cabinets" element={<Suspense fallback={<div className="min-h-screen" />}><LancasterCounty /></Suspense>} />
          <Route path="/chester-county-cabinets" element={<Suspense fallback={<div className="min-h-screen" />}><ChesterCounty /></Suspense>} />
          <Route path="/berks-county-cabinets" element={<Suspense fallback={<div className="min-h-screen" />}><BerksCounty /></Suspense>} />
          
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/contractor/login" element={<Suspense fallback={<div className="min-h-screen" />}><ContractorLogin /></Suspense>} />
          <Route path="/contractor/dashboard" element={<Suspense fallback={<div className="min-h-screen" />}><ContractorDashboard /></Suspense>} />
          <Route path="/contractor/projects/:id" element={<Suspense fallback={<div className="min-h-screen" />}><ProjectDetail /></Suspense>} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  );
};

export default App;
